import { createFileRoute } from '@tanstack/react-router';
import { RateiosPage, lerBuscaRateios } from '@/components/rateios';

export const Route = createFileRoute('/_app/custos/rateios')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaRateios(bruto),
  component: RateiosRota,
});

function RateiosRota() {
  return <RateiosPage busca={Route.useSearch()} />;
}
